export enum ApiLoadingStatusEnum {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  PENDING = "PENDING",
  IDLE = "IDLE",
}

export enum AppHeaderStatusEnum {
  QUERY = "QUERY",
  HEADER = "HEADER",
  NO_HEADER = "NO_HEADER",
}
